import { StatsCollector } from "../../stats/StatsCollector.js";
import { Logger } from "@ciaopeople/cp-shatsu/Logging";
import { isFunction } from "@ciaopeople/cp-shatsu/TypeChecking";
import { ClientSdkPublicInterface } from "../../sdk/ClientSdkPublicInterface.js";
import { DefaultCTAExecutor } from "./DefaultCTAExecutor.js";
import { EvaluatedAction } from "../EvaluatedAction.js";
import { EvaluationName } from "./EvaluatedActionExecutor.js";


export type ChainableEvaluation = (s: ClientSdkPublicInterface, logger: Logger) => Promise<EvaluatedAction<any>|null>;





export type NamedChainableEvaluation = {

    name: EvaluationName,
    evaluation: ChainableEvaluation,
    beforeForcedExecution?: () => void
};


export class ChainedCTAEvaluator extends DefaultCTAExecutor {
    
    protected evaluateNamedCTA(_name: EvaluationName, _forced: boolean): Promise<EvaluatedAction<any>> {
        return Promise.resolve(null);
    }

    private singletonValue: Promise<EvaluatedAction<any>>;

    constructor(
        protected sdk: ClientSdkPublicInterface,
        private readonly executionChain: ChainableEvaluation[],
        stats: StatsCollector
    ) {
        super(sdk, stats);
    }


    evaluateCTA(): Promise<EvaluatedAction<any>> {
        if(!this.singletonValue) {
            this.singletonValue = this.executionChain.reduce(
                (prev, el) => {
                    return prev.then(previousEvaluationResult => {
                        if(!previousEvaluationResult) {
                            return el(this.sdk, this.logger);
                        }
                        else return previousEvaluationResult;
                    });
                },
                Promise.resolve(null)
            );
        }
        return this.singletonValue;
    }

}


export class NamedChainedCTAEvaluator extends ChainedCTAEvaluator {

    

    private readonly mapped: { [k in EvaluationName]?: NamedChainableEvaluation } = {};


    constructor (
        sdk: ClientSdkPublicInterface,
        namedChain: NamedChainableEvaluation[],
        stats: StatsCollector
    ) {
        super(sdk, namedChain.map(el => el.evaluation), stats);
        namedChain.forEach((el) => {
            this.mapped[el.name] = el;
        });
    }

    protected evaluateNamedCTA(name: EvaluationName, forced: boolean): Promise<EvaluatedAction<any>> {
        if(name in this.mapped) {
            const named = this.mapped[name];
            if(forced && isFunction(named.beforeForcedExecution)) named.beforeForcedExecution();
            return named.evaluation(this.sdk, this.logger);
        }
        else Promise.resolve();

    }

}